// Galerie-Video (sections/main-product.liquid, [data-su-video]): Das hochaufloesende Vorschaubild (.su-video__poster) bleibt
// ueber dem Video, bis das Video wirklich laeuft und ein Bild gezeichnet hat, dann blendet es weich aus.
// Bleibt das Video stehen (Autoplay blockiert, Fehler), bleibt das Vorschaubild.
(() => {
  // Merkliste statt data-Attribut: gallery.js klont die Slides, ein Attribut wuerde mitkopiert und der Klon bliebe ohne Zuhoerer
  const armed = new WeakSet();
  const arm = (v) => {
    if (armed.has(v)) return;
    armed.add(v);
    const poster = v.parentElement && v.parentElement.querySelector('.su-video__poster');
    if (!poster) return;
    const out = () => poster.classList.add('is-out');
    const ready = () => {
      if ('requestVideoFrameCallback' in v) v.requestVideoFrameCallback(() => requestAnimationFrame(out));
      else requestAnimationFrame(out);
    };
    if (!v.paused && v.readyState >= 3 && v.currentTime > 0.05) ready();
    v.addEventListener('playing', ready);
    v.addEventListener('timeupdate', function tu() { if (v.currentTime > 0.1) { v.removeEventListener('timeupdate', tu); ready(); } });
  };
  const all = () => document.querySelectorAll('video[data-su-video]').forEach(arm);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  new MutationObserver(all).observe(document.documentElement, { childList: true, subtree: true });
})();
